import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { SupabaseContext } from '../App';

function Home() {
  const { supabase, session } = useContext(SupabaseContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [otp, setOtp] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const handleRequestOtpForSignup = async () => {
    if (!email.endsWith('@gmail.com')) {
      alert('Please use a @gmail.com email address.');
      return;
    }
    if (!name.trim()) {
      alert('Please enter your name.');
      return;
    }
    const response = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: { name: name.trim() },
        emailRedirectTo: window.location.origin,
      },
    });
    console.log('Signup response:', response);
    const { error } = response;
    if (error) {
      alert('Failed to send OTP: ' + error.message);
    } else {
      await supabase.auth.signOut();
      setOtpSent(true);
      alert('A 6-digit OTP has been sent to your Gmail! Please check your inbox or spam.');
    }
  };

  const handleVerifyOtpForSignup = async () => {
    const { error } = await supabase.auth.verifyOtp({
      email,
      token: otp,
      type: 'signup',
    });
    if (error) {
      alert('Invalid OTP: ' + error.message);
    } else {
      alert('Account created! Please log in.');
      setOtpSent(false);
      setIsNewUser(false);
    }
  };

  const handleLogin = async () => {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) alert('Login failed: ' + error.message);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  if (!session || (isNewUser && otpSent)) {
    return (
      <div className="page-container">
        <div className="auth-card">
          <h2>{otpSent ? 'Verify OTP' : isNewUser ? 'Sign Up' : 'Login'}</h2>
          <p className="subtitle">
            {otpSent ? 'Enter the 6-digit OTP sent to your Gmail' : isNewUser ? 'Create a new account' : 'Welcome back! Please log in.'}
          </p>
          <p className="description">
            Pixel Quiz is your go-to platform for creating, sharing, and participating in fun and challenging quizzes! Whether you’re a quiz master looking to craft your own questions or a participant eager to test your knowledge, Pixel Quiz makes it easy and enjoyable. With features like time limits, single or multiple attempts, and a history tracker to monitor your progress, you’ll have everything you need for an engaging quiz experience. Log in now to start exploring!
          </p>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="yourname@gmail.com"
            />
          </div>
          {isNewUser && !otpSent && (
            <div className="form-group">
              <label htmlFor="name">Your Name</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="John Doe"
              />
            </div>
          )}
          {!otpSent ? (
            <>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
              </div>
              <div className="button-group">
                <button className="primary-btn" onClick={isNewUser ? handleRequestOtpForSignup : handleLogin}>
                  {isNewUser ? 'Request OTP' : 'Login'}
                </button>
                <button className="secondary-btn" onClick={() => setIsNewUser(!isNewUser)}>
                  {isNewUser ? 'Already have an account? Login' : 'Need an account? Sign Up'}
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label htmlFor="otp">OTP</label>
                <input
                  id="otp"
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 6-digit OTP"
                  maxLength="6"
                />
              </div>
              <div className="button-group">
                <button className="primary-btn" onClick={handleVerifyOtpForSignup}>Verify OTP</button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="auth-card">
        <h2>Hi, {session.user.user_metadata.name || session.user.email.split('@')[0]}</h2>
        <p className="description">
          Pixel Quiz is your go-to platform for creating, sharing, and participating in fun and challenging quizzes! Whether you’re a quiz master looking to craft your own questions or a participant eager to test your knowledge, Pixel Quiz makes it easy and enjoyable. With features like time limits, single or multiple attempts, and a history tracker to monitor your progress, you’ll have everything you need for an engaging quiz experience.
        </p>
        <div className="vertical-button-group">
          <Link to="/create"><button className="primary-btn">Create a Quiz</button></Link>
          <Link to="/participate"><button className="primary-btn">Participate in Quiz</button></Link>
          <Link to="/history"><button className="primary-btn">View History</button></Link>
          <button className="secondary-btn" onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </div>
  );
}

export default Home;